// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";

const getOnClickHistoryBack = (pageLink: PageLinkModel | undefined) => {
    if (!pageLink?.url) {
        return undefined;
    }

    let onClick: (() => void) | undefined;

    if (
        typeof window !== "undefined" &&
        window.history.length > 1 &&
        document.referrer.includes(`${window.location.host}${pageLink.url}`)
    ) {
        onClick = () => window.history.back();
    }

    return onClick;
};

export default getOnClickHistoryBack;
